import React from 'react';
import { Box, ListItem, ListItemText, Tooltip } from '@mui/material';
import { item } from './styles';
import { User } from '../../types';

export interface ProgressListItemProps {
  text: string;
  created: number;
  approved: number;
  goal: number;
  user: User;
}

const ProgressListItem: React.FC<ProgressListItemProps> = ({ text, created, approved, user }) => (
  <>
    <ListItem
      disablePadding
      sx={{ ...item, display: 'flex', justifyContent: 'space-between', flexDirection: 'row' }}
    >
      <ListItemText>{text}</ListItemText>
      {user.is_case_reviewer ? (
        <Tooltip title={`${created} Cases submitted or in review process`}>
          <ListItemText sx={{ textAlign: 'right' }}>{created}</ListItemText>
        </Tooltip>
      ) : (
        <Tooltip title={`${approved} Cases Approved / ${created} Cases Created`}>
          <ListItemText sx={{ textAlign: 'right' }}>{`${approved} / ${created}`}</ListItemText>
        </Tooltip>
      )}
    </ListItem>
    <Box sx={{ m: 2 }} />
  </>
);

export default ProgressListItem;
